import { groupBy } from '../helpers/others'

class Condition
{
    constructor(el, formEl, fields, options) {
        this.el = el;
        this.fields = fields;
        this.options = options;
        this.conditions = options.conditions || {};
        this.masterConditions = new Map();

        // Abort if no conditions defined
        if (Object.keys(this.conditions).length === 0) return;

        this.onFieldChange = this.onFieldChange.bind(this);
        this.init();
    }
    init() {
        /** Group conditions by master field */
        for (const key in this.conditions) {
            if (this.conditions.hasOwnProperty(key)) {
                const condition = this.conditions[key];
                const {master_id: masterId, slave_id: slaveId} = condition;

                const slaves = this.fields.get(`${slaveId}`);
                const masters = this.fields.get(`${masterId}`);
                if (!slaves || !masters) continue;

                if (!this.masterConditions.has(`${masterId}`)) {
                    this.masterConditions.set(`${masterId}`, []);
                }
                
                let collection = this.masterConditions.get(`${masterId}`);
                collection.push(condition);
                this.masterConditions.set(`${masterId}`, collection);
            }
        }
        /** Bind 'changed' event listener to master fields */
        this.masterConditions.forEach((conditions, masterId) => {
            const masters = this.fields.get(`${masterId}`);
            masters.forEach(master => {
                if (master.parentNode.classList.contains('select')) {
                    master.parentNode.addEventListener('select:choose', event => {
                        this.onFieldChange(masterId);
                    });
                } else {
                    master.addEventListener('change', event => {
                        this.onFieldChange(masterId);
                    });
                }
            });
            this.onFieldChange(masterId);
        });
    }
    /**
     * Get's field checked value
     * @param {Array|object} masters 
     */
    getFieldValue(masters) {
        if (Array.isArray(masters)) {
            const checked = masters.find(master => master.checked);
            if (checked) {
                return parseInt(checked.value);
            }
        } else {
            return parseInt(masters.value);
        }
        return null;
    }
    /**
     * Process field condition
     * @param {*} masters 
     * @param {*} slaves 
     * @param {*} condition 
     */
    processCondition(masters, slaves, condition) {
        const showFunc = (slaves) => slaves.forEach(slave => {
            let closestSlave = slave.closest('div.field')
            if (closestSlave) closestSlave.classList.remove('d-none')
        });
        const hideFunc = (slaves) => slaves.forEach(slave => {
            let closestSlave = slave.closest('div.field')
            if (closestSlave) closestSlave.classList.add('d-none')
        });
        const disabledFunc = (slaves) => slaves.forEach(slave => slave.disabled = true);
        const enabledFunc = (slaves) => slaves.forEach(slave => slave.disabled = false);
        let conditionMeet = false;

        const value = this.getFieldValue(masters);

        switch(condition.operator) {
            case 'eq':
                conditionMeet = value === condition.option_id;
                break;
            case 'neq':
                conditionMeet = value !== condition.option_id;
                break;
        }

        if (conditionMeet) {
            switch(condition.action) {
                case 'show':
                    showFunc(slaves);
                    enabledFunc(slaves);
                    break;
                case 'hide':
                    hideFunc(slaves);
                    disabledFunc(slaves);
                    break;
            }
        } else {
            switch(condition.action) {
                case 'show':
                    hideFunc(slaves);
                    disabledFunc(slaves);
                    break;
                case 'hide':
                    showFunc(slaves);
                    enabledFunc(slaves);
                    break;
            }
        }
        return conditionMeet;
    }
    /**
     * Process condition when field value changes
     * @param {String} masterId
     */
    onFieldChange(masterId) {
        const masters = this.fields.get(`${masterId}`);
        const optionConditions = groupBy(this.masterConditions.get(`${masterId}`), condition => condition.option_id);

        let result = false;
        optionConditions.forEach( (conditions, optionId) => {
            // Skip condition processing if one condition meet
            if (result)
                return;

            const slaves = [];
            const condition = conditions[0];
            conditions.forEach(condition => slaves.push(this.fields.get(`${condition.slave_id}`)));

            result = this.processCondition(masters, slaves.flat(), condition);
        });
    }
}

export default Condition;